/**
 * TemplateListBuilderPage — hub Kreatora, Krok 2: Kreator Listy dla widoku `list`
 * encji szablonu w scope ADMIN.
 *
 * Cienki wrapper: layout admina + tab-shell `SystemModuleListBuilderPage` w trybie
 * `template` (trasa niesie `:slug/:entitySlug/:viewSlug` → tableId
 * `template:<code>:<entity>:<view>`; persystencję — odczyt z definicji szablonu,
 * zasiew kolumn, zapis na żądanie przez PATCH — robi adapter w `useTableLayout`).
 *
 * Routing: `/module-templates/:slug/entities/:entitySlug/views/:viewSlug/list-builder`.
 */

import { Layout } from '@/components/Layout';

import { SystemModuleListBuilderPage } from './system-modules/SystemModuleListBuilderPage';

export function TemplateListBuilderPage() {
  return (
    <Layout>
      <SystemModuleListBuilderPage scope="template" />
    </Layout>
  );
}
